import { PartnerWorkerProfile } from 'api/services/partner-worker/partner-worker-profile.schema';
import { PartnerWorkerInformationTab } from './partner-worker-information-tab';

type Props = {
  data: PartnerWorkerProfile;
};

export const PartnerWorkerDetailTabs = ({ data }: Props) => {
  return <PartnerWorkerInformationTab data={data} />;
};
